import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator'

export class EstablishmentDto {
  @ApiProperty({
    description: "ID de l'établissement",
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  id!: string

  @ApiProperty({
    description: "Nom de l'établissement",
    example: 'Collège Jean Moulin',
    type: 'string',
  })
  @IsNotEmpty()
  @IsString()
  name!: string

  @ApiPropertyOptional({
    description: "Nom court de l'établissement",
    example: 'Collège J. Moulin',
    type: 'string',
  })
  @IsOptional()
  @IsString()
  shortName?: string

  @ApiProperty({
    description: "Code UAI de l'établissement",
    example: '0751234A',
    type: 'string',
  })
  @IsNotEmpty()
  @IsString()
  uai!: string
}
